
import {Component, Prop, Vue} from 'vue-property-decorator'
import {IBugData} from '@/types/bug-types'
import {BugService} from '@/services/index'
import EditRemarks from '@/components/bug/edit_remarks/index.vue'

@Component({
    name: 'NewsTable',
    components: {
        EditRemarks
    }
})
export default class extends Vue {
    @Prop({required: true}) private bugList!: IBugData[]
    @Prop({required: false}) private updateBugCb!: Function

    private bugTypeMap = {
        0: '所有类型',
        1: '记者名抽取错误',
        2: '漏抽记者名',
        3: '分类问题',
        4: '文章排版问题',
        5: '标签抽取问题',
        6: '转载识别问题'
    }
    private statusMap: any = {
        toFix: 0,  // 待解决
        fixed: 1   // 已解决
    }

    // 解析字符串数组
    private parseArray(str: string): any[] {
        if (!str) return []
        try {
            return JSON.parse(str)
        } catch {
            return []
        }
    }

    // 检查是否有数据
    private hasData(str: string): boolean {
        const arr = this.parseArray(str)
        return arr && arr.length > 0
    }

    private async updateBug(bug: any) {
        const params = {id: bug.id, status: bug.status}
        const result = await BugService.update(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '操作成功'
            })
            this.updateBugCb && this.updateBugCb(bug)
        }
    }

    private async onTapTitle(data: any) {
        window.open('/news/' + data.id)
    }

    private onTapNews(id: string) {
        window.open('/news/' + id)
    }

    private onTapMedia(data: any) {
        window.open('/media/' + data.id + '/edit')
    }

    private onTapReporter(data: any) {
        window.open('/news/list?reporterId=' + data.id + '&name=' + data.name)
    }
    // 转载源标题跳转
    private onTapReprintItem(reprintFromStr: string) {
        const arr = this.parseArray(reprintFromStr)
        if (arr && arr[0] && arr[0].url) {
            window.open(arr[0].url)
        } else {
            this.$message({
                type: 'warning',
                message: '缺失目标路径，无法跳转'
            })
        }
    }
    // 获取转载源标题
    private getReprintTitle(reprintFromStr: string): string {
        const arr = this.parseArray(reprintFromStr)
        return arr && arr[0] && arr[0].title ? arr[0].title : '缺失标题'
    }
    // 获取转载源数据源
    private getReprintMedia(reprintFromStr: string): string {
        const arr = this.parseArray(reprintFromStr)
        return arr && arr[0] && arr[0].media ? arr[0].media : '缺失数据源'
    }
    private onBugFix(bug: any) {
        this.$confirm('确定此问题已经得到根治和解决?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            bug.status = 1
            this.updateBug(bug)
        })
    }

    private onBugUnFix(bug: any) {
        bug.status = 0
        this.updateBug(bug)
    }

    private onEditRemarks(bug: any) {
        (this.$refs.editRemarks as any).show(bug, () => {
            this.updateBugCb()
        })
    }
}
